module.exports = __webpack_public_path__ + "media/assets/good_at/PHP-d86783e591d9a2bff6176be3f6869c7a.png";